import React, { useEffect, useState } from 'react';

import CordobaLogo from '../../../../assets/images/header/logo-cordoba-blanco.svg';
import VedilogoColor from '../../../../assets/images/header/logo-vedi-color.svg';
import VediLogoBlanco from '../../../../assets/images/header/logo-vedi-blanco-nuevo.png';
import CordobaLogoMobile from '../../../../assets/images/nuevoIconoVeDiMobile.png';
import { isNative, redirectToCiDi } from '../../../../utils/generic-functions/genericFunctions';
import classes from './Toolbar.module.css';
import { useHistory } from 'react-router-dom/cjs/react-router-dom.min';
import { cidiActivo } from '../../../../services/segundoLoginServices';
import { useAppState } from '../../../../context/AppStateContext';
const Toolbar = props => {
  const { openLogin } = props;
  const [isCidiActivo, setIsCidiActivo] = useState(false);
  const [isCheckingCidi, setIsCheckingCidi] = useState(true);
  const { isLoading, setIsLoading } = useAppState();
  const history = useHistory();

  useEffect(() => {
    const CidiActivo = async () => {
      setIsLoading(true);
      setIsCheckingCidi(true);
      try {
        const data = await cidiActivo();
        await new Promise(res => setTimeout(res, 1000));
        if (!data.ok) {
          throw new Error(data.error || 'Error procesando la solicitud');
        }
        setIsCidiActivo(data.return);
      } catch (error) {
        console.log(error);
        setIsCidiActivo(false);
      } finally {
        setIsLoading(false);
        setIsCheckingCidi(false);
      }
    };
    CidiActivo();
  }, [setIsLoading]);

  const handleLogin = async () => {
    setIsLoading(true);
    try {
      if (isCidiActivo) {
        const response = await isNative();
        if (response) {
          openLogin();
        } else {
          redirectToCiDi();
        }
      } else {
        history.push('/segundo-login');
      }
    } finally {
      setIsLoading(false);
    }
  };

  const getButtonText = () => {
    if (isCheckingCidi) return 'Verificando...';
    return isCidiActivo ? 'Ingresar' : 'Login Alternativo';
  };

  const ButtonLoader = () => (
    <div className={classes.buttonLoader}>
      <div></div>
      <div></div>
      <div></div>
    </div>
  );

  const LoginButton = ({ isMobile = false }) => (
    <button
      disabled={isLoading || isCheckingCidi}
      className={
        isLoading || isCheckingCidi
          ? [classes.link, classes.buttonDisabled].join(' ')
          : [classes.link, classes.button].join(' ')
      }
      onClick={handleLogin}
      style={{ display: isMobile ? 'block' : 'flex' }}
    >
      {!isMobile && <img src={VedilogoColor} alt="vedi-logo-color" width="32" height="32" />}
      {(isLoading || isCheckingCidi) ? (
        <>
          <ButtonLoader />
          {getButtonText()}
        </>
      ) : (
        getButtonText()
      )}
    </button>
  );

  return (
    <>
      <div>
        <div className={classes.container}>
          <div>
            <img
              className={classes.logo}
              src={CordobaLogo}
              alt="cordoba-logo"
              width="75"
              height="75"
            />
            <img
              className={classes.logo}
              src={VediLogoBlanco}
              alt="cordoba-logo"
              width="75"
              height="75"
            />
          </div>
          <LoginButton />
        </div>

        <div className={classes.containerMobile}>
          <img src={CordobaLogoMobile} alt="cordoba-logo-mobile" width="100" height="100" />
          <LoginButton isMobile={true} />
        </div>
      </div>
    </>
  );
};

export default Toolbar;
